import { render, staticRenderFns } from "./PMCountedTabs.vue?vue&type=template&id=7b9b2056&"
import script from "./PMCountedTabs.vue?vue&type=script&lang=ts&"
export * from "./PMCountedTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PMCountedTabs.vue?vue&type=style&index=0&id=7b9b2056&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports